import {asyncRouterMap, constantRouterMap, defaultRouterMap} from '@/router'

/**
 * 生成路由表
 * @param asyncRouterMap
 * @param menus
 */
const filterAsyncRouter = function (asyncRouterMap, menus) {
  let accessedRouters = []
  for (var i = 0; i < menus.length; i++) {
    if (!menus[i].url && menus[i].children && menus[i].children.length > 0) {
      const children = filterAsyncRouter(asyncRouterMap, menus[i].children)
      accessedRouters = accessedRouters.concat(children)
    } else {
      let page = null
      asyncRouterMap.forEach(item => {
        if (item.url.indexOf(menus[i].url) >= 0) {
          page = {...item, children: [...item.children], url: menus[i].url}
          page.children[0] = {...page.children[0], path: menus[i].url.replace('/', ''), name: menus[i].label}
          page.children[0].meta = {...page.children[0].meta, title: menus[i].label}
          return false
        }
      })
      if (page) {
        accessedRouters.push(page)
        continue
      }
    }
  }
  return accessedRouters
}

const getCurrentMenuInfo = function (menus, path) {
  let flag = false
  for (var i = 0; i < menus.length; i++) {
    if (menus[i].url === path && menus[i].url && path) {
      flag = true
    } else if (menus[i].children && menus[i].children.length > 0) {
      flag = getCurrentMenuInfo(menus[i].children, path)
    }
    if (flag) {
      break
    }
  }
  return flag
}

const routersInfo = function (menus, path) {
  let current = {appId: '', applicationName: '', applicationNo: '', menuTree: [], otherMenuTree: []}
  for (let i = 0; i < menus.length; i++) {
    const flag = getCurrentMenuInfo(menus[i].menuTree, path)
    if (flag) {
      current.appId = menus[i].appId
      current.applicationName = menus[i].applicationName
      current.applicationNo = menus[i].applicationNo
      current.menuTree = menus[i].menuTree
    } else {
      current.otherMenuTree.push(menus[i].menuTree)
    }
  }
  return current
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: null
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.routers = constantRouterMap.concat(routers)
    },
    SET_ADD_ROUTERS: (state, routerInfo) => {
      state.addRouters = routerInfo.routers.concat(routerInfo.otherRouters).concat(defaultRouterMap)
    },
    SET_APP_ID: (state, appId) => {
      state.appId = appId
    }
  },
  actions: {
    GenerateRoutes ({ commit }, menuInfo) {
      return new Promise(resolve => {
        const data = routersInfo(menuInfo.menus, menuInfo.path)
        let routers = filterAsyncRouter(asyncRouterMap, data.menuTree)
        let otherRouters = []
        data.otherMenuTree.forEach(item => {
          const filterRouter = filterAsyncRouter(asyncRouterMap, item)
          otherRouters = otherRouters.concat(filterRouter)
        })
        commit('SET_ROUTERS', routers)
        commit('SET_ADD_ROUTERS', {routers, otherRouters})
        resolve(data)
      })
    },
    GenerateCurrentRoutes ({ commit }, menuInfo) {
      return new Promise(resolve => {
        const data = routersInfo(menuInfo.menus, menuInfo.path)
        let routers = filterAsyncRouter(asyncRouterMap, data.menuTree)
        commit('SET_ROUTERS', routers)
        resolve(data)
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js